import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './CommonPrivacy.css';
import Footer from "../../Footer";
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import Topbar from "../../Topbar";
import Image from 'react-bootstrap/Image';

const CommonPrivacy = () => {
const [loading,setLoading] = useState(true);
const [privacy, setPrivacy] = useState('<p></p>');
const [img, setImg] = useState('');

    useEffect(() => {
        document.title = `Privacy | Local Bells`;
        document.getElementById('bodywrap').className = 'cneprivacy';

        /* Start get privacy policy */
        let formData = new FormData();
        formData.append('type', 'privacy');
            API.post('get_page', formData)
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setImg(response.data.data.image);
                  setPrivacy(response.data.data.content);
                }                  
            }).catch(error => {
                  setLoading(false);
            });  
        /* End get privacy policy */

    }, []);

    return (
        <>
        <Topbar />
            <section className="main-cont-box">
                <Container>
                    <Row>
                        {/*<NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />*/}
                        <Col md={12} lg={12} xl={12} xxl={12} className='main-cont-box-right'>
                            {/*<Header toggleSidebar={toggleSidebar} />*/}
                            <div className='nei-cont'>
                                <div className='white-box static-cont'>
                                    <Row>
                                        <Col>
                                            
                                            <h3>Privacy Policy</h3>
                                        </Col>
                                    </Row>
                                    <Row className=''>
                                        {img && (
                                        <Col xs={12} className="mb-4">
                                                <Image
                                                  src={img}
                                                  className="img-fluid "
                                                  alt="wp"
                                                />
                                        </Col>
                                        )}
                                        <Col xs={12}>
                                            <div dangerouslySetInnerHTML={{__html: privacy}} />
                                        </Col>
                                    </Row>
                                </div>
                                                             
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}  
        </>
    )
}

export default CommonPrivacy;


